module.exports = __webpack_public_path__ + "img/puppy-management.a3cd6c43.png";